import React from 'react';
import { DisplayFieldsFragment } from '../../../../../../../../../../generated/core-api/graphql-react-query';

interface CardDisplays {
  card: { id: string; title: string };
  count: number;
}

const FIRST_N = 5;

export default function useDisplayCards(displays: DisplayFieldsFragment[] | undefined) {
  const [seeMore, setSeeMore] = React.useState(false);

  const filteredCards = React.useMemo(() => {
    if (!displays) return [];

    const groupedDisplays = displays.reduce((acc, curr) => {
      const index = acc.findIndex((item) => item.card.id === curr.card.id);
      if (index !== -1) {
        return acc.map((item, i) => (i === index ? { ...item, count: item.count + 1 } : item));
      }
      return [...acc, { card: curr.card, count: 1 }];
    }, [] as CardDisplays[]);

    return groupedDisplays.sort((a, b) => {
      const countA = a.count ?? 0;
      const countB = b.count ?? 0;
      if (countB !== countA) {
        return countB - countA;
      }
      return a.card.title.localeCompare(b.card.title);
    });
  }, [displays]);

  const cards = React.useMemo(() => {
    if (seeMore) {
      return filteredCards;
    }
    return filteredCards.slice(0, FIRST_N);
  }, [seeMore, filteredCards]);

  return {
    cards,
    seeMore: filteredCards.length > FIRST_N ? {
      displayAll: seeMore,
      toggle: () => setSeeMore(!seeMore),
    } : undefined,
  };
}
